import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useCarrierOrg } from '../../hooks/useCarrierOrg';
import { carrierApi } from '../../firebase/functionsService';
import { ui } from './carrierStyles';

// «Forlat firmaet» for alle som ikke er eier (admin og dispatcher). Eieren kan ikke forlate firmaet.
export default function LeaveOrgCard() {
  const navigate = useNavigate();
  const { refreshUserDoc } = useAuth();
  const { orgId, org, isOwner } = useCarrierOrg();
  const [error, setError] = useState('');

  if (isOwner) return null;

  async function leave() {
    if (!window.confirm(`Forlate ${org?.orgName ?? 'firmaet'}?`)) return;
    setError('');
    try {
      await carrierApi.leaveCarrierOrg({ orgId });
      await refreshUserDoc();
      navigate('/');
    } catch (err) {
      setError(err.message || 'Kunne ikke forlate firmaet');
    }
  }

  return (
    <div style={ui.card}>
      <h2 style={ui.h2}>Forlat firmaet</h2>
      <p style={ui.hint}>Du mister tilgangen til firmaets biler og sjåfører. Eieren kan ikke forlate firmaet.</p>
      {error && <p role="alert" style={ui.error}>{error}</p>}
      <button type="button" style={ui.btnDanger} onClick={leave}>Forlat firmaet</button>
    </div>
  );
}
